import React from 'react';
import NavbarDropdown from './NavbarDropdown';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { flatRoutes } from 'helpers/utils';
import NavbarDropdownApp from './NavbarDropdownApp';
import NavbarDropdownPages from './NavbarDropdownPages';
import NavbarDropdownModules from './NavbarDropdownModules';
import { useAppContext } from 'providers/AppProvider';
import { useSiteMaps } from 'routes/siteMaps';
import { useUserContext } from '../../../providers/UserProvider';

const NavbarTopDropDownMenus = () => {
  const {
    config: { navbarCollapsed, showBurgerMenu },
    setConfig,
  } = useAppContext();

  const {
    productsRoutes,
    ordersRoutes,
    inventoryRoutes,
    returnRoutes,
    fileUploadRoutes,
    administrationRoutes,
    // dashboardRoutes,
    // appRoutes,
    // pagesRoutes,
    // modulesRoutes,
    // documentationRoutes,
  } = useSiteMaps();

  const { user } = useUserContext();

  const handleDropdownItemClick = () => {
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  return (
    <>
      <NavbarDropdown title={productsRoutes.label}>
        {productsRoutes.children.map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown>

      {/*<NavbarDropdown title={purchaseOrderRoutes.label}>*/}
      {/*  {purchaseOrderRoutes.children.map(route => (*/}
      {/*    <Dropdown.Item*/}
      {/*      key={route.name}*/}
      {/*      as={Link}*/}
      {/*      className={route.active ? 'link-600' : 'text-500'}*/}
      {/*      to={route.to}*/}
      {/*      onClick={handleDropdownItemClick}*/}
      {/*    >*/}
      {/*      {route.name}*/}
      {/*    </Dropdown.Item>*/}
      {/*  ))}*/}
      {/*</NavbarDropdown>*/}

      <NavbarDropdown title={ordersRoutes.label}>
        {ordersRoutes.children.map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown>

      <NavbarDropdown title={inventoryRoutes.label}>
        {inventoryRoutes.children.map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown>

      <NavbarDropdown title={returnRoutes.label}>
        {returnRoutes.children.map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown>

      <NavbarDropdown title={fileUploadRoutes.label}>
        <Dropdown.Item
          key={fileUploadRoutes.label}
          as={Link}
          className={fileUploadRoutes.active ? 'link-600' : 'text-500'}
          to={fileUploadRoutes.to}
          onClick={handleDropdownItemClick}
        >
          {fileUploadRoutes.label}
        </Dropdown.Item>
      </NavbarDropdown>

      {!!user?.is_superuser && (
        <NavbarDropdown title={administrationRoutes.label}>
          {administrationRoutes.children.map(route => (
            <Dropdown.Item
              key={route.name}
              as={Link}
              className={route.active ? 'link-600' : 'text-500'}
              to={route.to}
              onClick={handleDropdownItemClick}
            >
              {route.name}
            </Dropdown.Item>
          ))}
        </NavbarDropdown>
      )}
    </>
  );
};

export default NavbarTopDropDownMenus;
